import { STORY_CHAPTERS } from "@/lib/content";
import { Reveal } from "@/components/site/Reveal";

export default function StoryChapters() {
  return (
    <section className="bg-rp-bg" data-testid="story-chapters">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="border-t border-white/10">
          {STORY_CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.05}>
              <div
                className="group grid grid-cols-1 gap-6 border-b border-white/10 py-12 transition-colors duration-300 hover:bg-white/[0.015] md:grid-cols-12 md:gap-10 md:py-16"
                data-testid={`story-chapter-${c.num}`}
              >
                <div className="md:col-span-3">
                  <span className="font-mono text-5xl font-light text-white/15 transition-colors duration-300 group-hover:text-rp-accent md:text-7xl">
                    {c.num}
                  </span>
                </div>
                <div className="md:col-span-9">
                  <h3 className="font-display text-2xl font-light uppercase tracking-tight text-white md:text-4xl">
                    {c.title}
                  </h3>
                  <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/55 md:text-lg">
                    {c.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
